<template>
  <div class='loader'>
    <i class="fa fa-fw fa-circle-o-notch fa-spin fa-3x"></i>
   </div>
</template>

<script>
  export default {
  }
</script>

<style scoped>
  .loader {
    margin: 20px auto;
    text-align: center;
  }
</style>
